import React, { useState, useEffect } from "react";
import "./style.scss";
import {
  getPredefineOptionsList,
  getCountersList,
  getCountersSessions,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import newBadge from "../../../../../assets/images/new-mentor.png";
import goldBadge from "../../../../../assets/images/gold-mentor.png";
import silveradge from "../../../../../assets/images/silver-mentor.png";
import platinumBadge from "../../../../../assets/images/platinum-mentor.png";
import StarIcon from "../../../../../assets/svg/star.svg";
// import {
//   FacebookShareButton,
//   FacebookIcon,
//   TwitterIcon,
//   TwitterShareButton,
//   LinkedinIcon,
//   LinkedinShareButton,
// } from "react-share";
import shareRounded from "./img/share-round.svg";

import startupIndia from "./img/startup-india.png";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Divider,
  Collapse,
  Button,
  IconButton,
  Tooltip,
} from "@material-ui/core";

import {
  getMentorStartUpApplicationList,
  setMentorStartUpStatus,
  getMentorHome,
  getCountersMentorList,
  getCohortMentorList,
} from "../dependencies/action";
import Select from "react-select";
import * as moment from "moment";
import axios from "axios";
import { withRouter, useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import twoGears from "../../../../../assets/svg/twoGears.svg";
import cohortIcon from "../../../../../assets/svg/dashboard/cohort_application.svg";
import startupIcon from "../../../../../assets/svg/dashboard/startup_application.svg";
import pdfFile from "../../../../../assets/pdf/Mentor_Toolkit_MAARG_guide.pdf";
import HorizontalBarChart from "../../Chart";
import swal from "sweetalert";
import Pagination from "react-js-pagination";
import Chart from "react-apexcharts";
import mentorshipIcon from "../../../../../assets/svg/cohort_program_icon.svg";
import api from "../../../../common/dependencies/utils/Api";

import Modal from "./Modal/modal";

import { getNewMessagesDash } from "../../StartupDashboard/dependencies/action";

import {
  MENTORSHIP_STARTUP_APPLICATION_STATUS,
  VIEW_COUNTER_SESSIONS,
  VIEW_COUNTER_HOURS,
  MENTORSHIPS_COUNTER,
  API_URL,
} from "../../../../common/constants/ApplicationUrl";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { PRODUCTION_MOVE_HIDDEN } from "../../../../common/constants/actionConstants";
import { types } from "../../../../common/dependencies/reducer/comingSoonReducer";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const customStyles = {
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    minHeight: "45px",
    color: "rgb(121, 193, 206)",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
    };
  },
};

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "10px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
  hoverEffect: {
    boxShadow: theme.shadows[19],
  },
}));

export const ColumnNameAdmin = [
  {
    value: "sn",
    text: "NO.",
    sort: false,
  },
  {
    value: "startupName",
    text: "STARTUP NAME",
    sort: true,
  },
  {
    value: "applicationid",
    text: "APPLICATION ID",
    sort: true,
  },
  {
    value: "applicationdate",
    text: "APPLICATION DATE",
    sort: true,
  },
  {
    value: "applicationform",
    text: "APPLICATION FORM",
    sort: false,
  },
  {
    value: "matchStatus",
    text: "MATCH STATUS",
    sort: false,
  },
  {
    value: "applicationstatus",
    text: "APPLICATION STATUS",
    sort: false,
  },
];

const MentorHome = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }

    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };

    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const html = document.getElementsByTagName("html")[0];

  const {
    getMentorHome,
    DashboardMentorHomeList,
    getPredefineOptionsList,
    getMentorStartUpApplicationList,
    getListData,
    getCountersList,
    getSession,
    getCountersSessions,
    getCounter,
    getListDataPaginate,
    getCountersMentorList,
    getCounterMentor,
    getNewMessagesDash,
    getNewMessagesData,
    getCohortMentorList,
    getCohortTableData,
    getListCohortData,
    // getCohortTableData,
  } = props;

  const classes = useStyles();

  const [isApproved, setApproved] = useState(
    DashboardMentorHomeList &&
      DashboardMentorHomeList.applicationStatus === "SUBMITTED"
      ? false
      : true
  );
  const [activePage, setActivePage] = useState(1);
  const [indexCounter, setIndexCounter] = useState(0);
  const [session, setSession] = useState();
  const [hours, setHours] = useState();
  const [counterData, setCounterData] = useState();
  const [cohortRedirection, setCohortRedirection] = useState("");
  //change this to true to show, and false to hide
  const [modalOpen, setModalOpen] = useState(true);
  const [mentorCounter, setMentorCounter] = useState(false);
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const history = useHistory();
  useEffect(() => {
    cohortApplicationTable();
  }, []);
  const approvalOptions = [
    {
      value: "Accept",
      label: "Accept",
    },
    { value: "Decline", label: "Decline" },
  ];

  const [formData, setFormData] = useState();
  const [commentsData, setCommentsData] = useState();
  let value = localStorage.getItem("SavedLoggedInData");
  let LoginData = JSON.parse(value);
  function getQuarter() {
    var today = new Date();
    var year = new Date().getFullYear();
    var quarter = Math.floor((today.getMonth() + 3) / 3);
    if (quarter == 1) {
      return `Oct ${year - 1} To Dec ${year - 1}`;
    } else if (quarter == 2) {
      return `Jan ${year} To Mar ${year}`;
    } else if (quarter == 3) {
      return `Apr ${year} To Jun ${year}`;
    } else {
      return `Jul ${year} To Sept ${year}`;
    }
  }
  const once = () => {
    let logged = localStorage.getItem("logged");

    if (logged) {
      localStorage.setItem("logged", "false");
      setMentorCounter(false);
    } else {
      localStorage.setItem("logged", "true");
      setMentorCounter(true);
    }
  };

  useEffect(() => {
    once();
  }, []);

  useEffect(() => {
    const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    setTimeout(() => {
      localStorage.removeItem("setloggedin");
    }, 1000);

    // props.openLoader();
    // axios({
    //   url: MENTORSHIPS_COUNTER,
    //   method: "POST",
    //   data: {
    //     mentorId: value?.id,
    //   },
    // })
    api
      .POST(MENTORSHIPS_COUNTER, {
        mentorId: value?.id,
      })
      .then((res) => {
        setCounterData(res?.data?.data);
        // props.closeLoader();
      })
      .catch((err) => {
        // props.closeLoader();
      });
  }, []);

  useEffect(() => {
    html.style.overflow = "auto";

    setTimeout(() => {
      localStorage.removeItem("mentorMentorships");
      localStorage.removeItem("cohortMentors");
      localStorage.removeItem("cohortStartup");
      localStorage.removeItem("myrequestMenu");
      localStorage.removeItem("startupListMentor");
      localStorage.removeItem("cohortAdminMentorships");
      localStorage.removeItem("CohortMentorRequest");
      localStorage.removeItem("cohortApplicationMentor");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("cohortMatchTable");
      localStorage.removeItem("CohortGroupSession");
    }, 1000);
    localStorage.removeItem("path");
    let params = {
      id: JSON.parse(localStorage.getItem("SavedLoggedInData")).id, //  id of logged in user
    };
    getNewMessagesDash(params);
  }, []);
  useEffect(() => {
    if (history?.location?.state === "cohortForm") {
      props.setSelectedMenu("MyCohortMentorDashboard");
      history.push(`/dashboard`);
    } else if (history?.location?.state === "MyCohortMentorDashboard") {
      props.setSelectedMenu("MyCohortMentorDashboard");
      history.push(`/dashboard`);
    } else if (history?.location?.state === "cohortNewDashboard") {
      props.setSelectedMenu("MyCohortMentorDashboard");
      history.push(`/dashboard`);
    }
    // cohortApplicationTable();
  }, []);
  useEffect(() => {
    if (getListData?.data?.length > 0) {
      setFormData(getListData.data);
    }
  }, [getListData]);
  useEffect(() => {
    let params = {
      id: props.loginData ? props.loginData.id : "",
    };
    getMentorHome(params);
  }, [getMentorHome]);
  useEffect(() => {
    if (DashboardMentorHomeList) {
      if (DashboardMentorHomeList?.comments?.length > 30) {
        let subData = DashboardMentorHomeList.comments.substring(0, 30);
        setCommentsData(subData);
      } else {
        setCommentsData(DashboardMentorHomeList.comments);
      }
    }
  }, []);
  const callListFunction = (pageNumber) => {
    let params = {
      mentorId: LoginData.id,
      status: "PENDING",
      pageFilter: {
        currentPage: pageNumber,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    getMentorStartUpApplicationList(params);
  };
  useEffect(() => {
    callListFunction(0);
  }, []);

  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    setApproved(
      DashboardMentorHomeList && DashboardMentorHomeList.applicationStatus
    );
  }, []);
  useEffect(() => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      state: "", // optional
      industry: "", // optional
      function: "", // optional
      stage: "", // optional
    };
    getCountersList(params);
  }, []);
  useEffect(() => {
    setGraphData();
  }, [getCounterMentor]);
  const [UpperdataMentor, setUpperdataMentor] = useState([
    [
      "",
      "",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
    ["", 0, "color: #e4c8f1", null],
    ["", 0, "color: #d1b2de", null],
    ["", 0, "color: #bdb1e3", null],
  ]);

  const setGraphData = () => {
    let data = [
      [
        "",
        "",
        { role: "style" },
        {
          sourceColumn: 0,
          role: "style",
          type: "string",
          calc: "stringify",
        },
      ],
      [
        "",
        getCounterMentor !== undefined ? getCounterMentor.total : 0,
        "color: #9e94c7",
        null,
      ],

      [
        "",
        getCounterMentor !== undefined ? getCounterMentor.accepted : 0,
        "color: #bdb1e3",
        null,
      ],
      [
        "",
        getCounterMentor !== undefined ? getCounterMentor.rejected : 0,
        "color: #e4c8f1",
        null,
      ],
    ];
    setUpperdataMentor(data);
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      mentorId: LoginData.id,
      status: "PENDING",
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    getMentorStartUpApplicationList(params);
  };
  const getAppId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const setUpdateApplicationStatus = (status, searchId) => {
    if (status != "Select") {
      let params = {
        searchId: searchId,
        mentorId: LoginData.id,
        status: status,
      };
      api
        .POST(`${MENTORSHIP_STARTUP_APPLICATION_STATUS}`, params)
        .then((response) => {
          const { data, status } = response || {};
          if (response === undefined) {
            swal({
              title: "WARNING",
              text: `Failed to  ` + params.status + ` Request `,
              icon: "info",
            });
            return false;
          }
          if (status === 200) {
            window.location.reload();
            swal({
              title: "Success",
              text: `Request Accepted Successfully `,
              icon: "success",
            });
            return response.data;
          } else {
            return { status: false };
          }
        })
        .catch((e) => {
          return Promise.reject(e);
        });
    }
  };

  const ViewProfile = (item) => {
    const currentRoute = window.location.href;
    let sample;
    sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
    let reRoute = window.open(
      sample + `/mentor-profile/${encryptAES2(item?.email_id, PROFILE_KEY)}`,
      "_blank"
    );
    // let reRoute = window.open(
    //   sample + `/mentor-profile/${item.email_id}`,
    //   "_blank"
    // );
    reRoute.id = item.email_id;
  };
  const encryptAES2 = (text, key) => {
    let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(
      CryptoJS.enc.Hex
    );

    let aesUtil = new AesUtil(128, 1000);
    let ciphertext = aesUtil.encrypt(salt, iv, key, text);

    let aesText = iv + "::" + salt + "::" + ciphertext;

    return btoa(aesText);
  };

  const ViewMentorApplication = (applicationId) => {
    setIndexCounter(applicationId.id);
    const currentRoute = window.location.href;
    let sample;
    sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

    let reRoute = window.open(sample + "/view-StartupApplication", "_blank");
    reRoute.id = applicationId.dpiitNumber;
  };
  const ViewMentorApplicaiton = (
    DashboardMentorHomeList,
    applicationId,
    applicationStatus,
    applicationView
  ) => {
    if (
      applicationStatus === "REQUESTINFO" ||
      applicationStatus === "VERIFIED"
    ) {
      if (applicationView === "ApplicationView") {
        let reRoute = window.open(
          `/view-application/${applicationId}`,
          "_blank"
        );
        reRoute.id = applicationId;
        reRoute.fromModule = "mentorDashboardHome";
      } else if (applicationStatus === "VERIFIED") {
        history.push({
          pathname: "/become-a-mentor",
          state: DashboardMentorHomeList && DashboardMentorHomeList,
          action: applicationStatus,
          fromModule: "mentorDashboardHome",
        });
      } else if (applicationStatus === "REQUESTINFO") {
        history.push({
          pathname: "/become-a-mentor",
          state: DashboardMentorHomeList && DashboardMentorHomeList,
          action: "EditApplication",
          fromModule: "mentorDashboardHome",
        });
      } else {
        // alert("else")
        history.push({
          pathname: "/become-a-mentor",
          state: DashboardMentorHomeList && DashboardMentorHomeList,
          action: "EditApplication",
          fromModule: "mentorDashboardHome",
        });
      }
    } else if (applicationStatus === "DRAFT") {
      history.push({
        pathname: "/become-a-mentor",
        state: DashboardMentorHomeList && DashboardMentorHomeList,
        fromModule: "mentorDashboardHome",
      });
    } else {
      let reRoute = window.open(
        sample + `/view-application/${applicationId}`,
        "_blank"
      );
      reRoute.id = applicationId;
      reRoute.fromModule = "mentorDashboardHome";
    }
  };

  const redirectProfile = (dpiitNo, reqId) => {
    let reRoute = window.open(sample + "/startup-profile", "_blank");
    reRoute.id = dpiitNo;
    setIndexCounter(reqId);
  };
  const getMentorId = (string) => {
    const value = string.substring(string.length - 6);
    return "M" + value;
  };
  const getApplicationId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };

  const seriesLabelColors = [
    "#9e94c7",
    "#bdb1e3",
    "#d1b2de",
    "#e4c8f1",
    "#8072ab",
  ];

  const seriesLabels = [
    "Till Date Scheduled",
    "Total Accepted",
    "Total Declined",
    "Total Rejected",
    "Total Drafts",
  ];

  const mentorHours = [
    "Till Date Scheduled",
    "Till Date Completed",
    "This Quarter Scheduled",
    "This Quarter Completed",
    "Upcoming",
  ];

  const mentorSessions = [
    "Till Date Scheduled",
    "Till Date Completed",
    "This Quarter Scheduled",
    "This Quarter Completed",
    "Upcoming",
  ];

  const optionshours = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          mentorHours[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: ["", "", "", "", ""],
    },
  };

  const optionsessions = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          mentorSessions[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: ["", "", "", "", ""],
    },
  };

  const options = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        // if (dataPointIndex == 8) {
        //   return "#7E36AF";
        // } else {
        //   return "#D9534F";
        // }
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          seriesLabels[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: ["", "", "", "", ""],
    },
  };
  const seriesMentor = [
    {
      data: [
        getCounterMentor !== undefined ? getCounterMentor.total : 0,
        getCounterMentor !== undefined ? getCounterMentor.accepted : 0,
        getCounterMentor !== undefined ? getCounterMentor.rejected : 0,
        0,
        0,
      ],
    },
  ];
  const seriesMentorHours = [
    {
      data: [
        hours ? parseFloat(hours.tillDateScheduledHours).toFixed(2) : 0,
        hours ? parseFloat(hours.tillDateCompletedHours).toFixed(2) : 0,
        hours ? parseFloat(hours.quarterScheduledHours).toFixed(2) : 0,
        hours ? parseFloat(hours.quarterCompletedHours).toFixed(2) : 0,
        hours ? parseFloat(hours.upcomingHours).toFixed(2) : 0,
      ],
    },
  ];
  const seriesMentorSessions = [
    {
      data: [
        session ? parseFloat(session.tillDateScheduled).toFixed(2) : 0,
        session ? parseFloat(session.tillDateCompleted).toFixed(2) : 0,
        session ? parseFloat(session.quarterScheduled).toFixed(2) : 0,
        session ? parseFloat(session.quarterCompleted).toFixed(2) : 0,
        session ? parseFloat(session.upcoming).toFixed(2) : 0,
      ],
    },
  ];
  useEffect(() => {
    let params = {
      mentorId: LoginData.id,
    };
    getCountersMentorList(params);

    // axios({
    //   url: VIEW_COUNTER_SESSIONS,
    //   method: "POST",
    //   data: {
    //     mentorId: LoginData.id,
    //   },
    // })
    api
      .POST(VIEW_COUNTER_SESSIONS, {
        mentorId: LoginData.id,
      })
      .then((res) => {
        setSession(res.data?.data);
      })
      .catch((err) => {});

    // axios({
    //   url: VIEW_COUNTER_HOURS,
    //   method: "POST",
    //   data: {
    //     mentorId: LoginData.id,
    //   },
    // })
    api
      .POST(VIEW_COUNTER_HOURS, {
        mentorId: LoginData.id,
      })
      .then((res) => {
        setHours(res.data?.data);
      })
      .catch((err) => {});
  }, []);

  const [iconsCollapse, setIconsCollapse] = useState(false);

  const cohortApplicationTable = () => {
    let params = {
      organization_name: "",

      mentorId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      industry: "",
      function: "",
      stage: "",
      cohortId: "",
      requestStatus: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 9,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      fromStartup: false,
      fromMentor: true,
    };
    getCohortMentorList(params);
  };

 
  useEffect(() => {
    if (
      getListCohortData !== undefined &&
      getListCohortData !== "" &&
      getListCohortData !== null &&
      getListCohortData?.length > 0
    ) {
      let arr = [];
      // arr.push({date:"2023-08-12",cohortId:"64c780962037ab524f9f1ee9",cohortAdminId:"62d8c75d24ace2514c1488a3"});
      // arr.push({date:"2023-08-09",cohortId:"64c780962037ab524f9f1ee9",cohortAdminId:"62d8c75d24ace2514c1488a1"});
      // arr.push({date:"2023-08-16",cohortId:"64c780962037ab524f9f1ee9",cohortAdminId:""});
      // arr.push({date:"2023-08-14",cohortId:"64c780962037ab524f9f1ee9",cohortAdminId:""});
      getListCohortData.forEach((element) => {
        if(element?.cohortApplication?.nextSession !== null && element?.cohortApplication?.nextSession !== undefined && element?.cohortApplication?.nextSession !== "" )
        {
          arr.push({
            date: moment(element?.cohortApplication?.nextSession).format("YYYY/MM/DD"),
            cohortId: element?.cohortId,
            cohortAdminId: element?.cohortAdminId,
          });
        }
      
      });
      let nearestDate;
      let nearestDate2;
      const dateToCheckFor = moment().format("YYYY/MM/DD");
      arr.forEach((element) => {
        // let diff = moment(element?.date).diff(moment(dateToCheckFor), "days");
        // if (diff > 0) {
          if (nearestDate) {
            if (moment(element?.date).diff(moment(nearestDate), "days") < 0) {
              nearestDate = element?.date;
              nearestDate2 = element;
            }
          } else {
            nearestDate = element?.date;
            nearestDate2 = element;
          }
        // }
      });
      if (
        nearestDate !== undefined &&
        nearestDate !== null &&
        nearestDate !== ""
      ) {
        setCohortRedirection(nearestDate2);
      }
    }
  }, [getListCohortData]);

  return (
    <div className="mentor-dashboard maindashboardMentorappli">
      {mentorCounter ? (
        <Modal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          // modalData={modalData}
        />
      ) : (
        ""
      )}
      <div className="col-md-12 col-sm-12 col-lg-12 wow fadeInDown text-center upperheaderbody">
        <h3 className="mb-0">
          <a title="" tabindex="0" className="homepageSecondHeader">
            MAARG Portal by Startup India
          </a>
        </h3>
        <h3 className="dashboard-sub-heading homepageFirstHeader">
          MY MENTOR DASHBOARD{" "}
        </h3>
        <h3 className="dashboard-sub-heading homepageFirstHeader">
          My ‘Become A Mentor’ Application Status{" "}
        </h3>
      </div>
      {(DashboardMentorHomeList &&
        DashboardMentorHomeList.applicationStatus === "SUBMITTED") ||
      (DashboardMentorHomeList &&
        DashboardMentorHomeList.applicationStatus === "DRAFT") ||
      (DashboardMentorHomeList &&
        DashboardMentorHomeList.applicationStatus === "REJECTED") ||
      (DashboardMentorHomeList &&
        DashboardMentorHomeList.applicationStatus === "REQUESTINFO") ||
      (DashboardMentorHomeList &&
        DashboardMentorHomeList.applicationStatus === "UPDATEDINFO") ? (
        <div className="applicationBox sm-p-0 sm-m-0 lg-p-0 lg-m-0">
          <div className="container lg-p-0 lg-m-0 sm-p-0 sm-m-0">
            <div className="mentor-content mt-20 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
              <div className="row lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0  d-flex justify-content-center">
                  <img
                    style={{
                      height: "150px",
                      width: "auto",
                      maxHeight: "160px",
                    }}
                    src={
                      DashboardMentorHomeList &&
                      DashboardMentorHomeList.uploadProfilePic
                        ? DashboardMentorHomeList.uploadProfilePic
                        : hashImage
                    }
                  />
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      MENTOR NAME
                    </h5>
                    <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      {DashboardMentorHomeList &&
                        DashboardMentorHomeList.full_name}{" "}
                    </h4>
                  </div>
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      MENTOR ID
                    </h5>
                    <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      {"-"}
                    </h4>
                  </div>
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      APPLICATION DATE
                    </h5>
                    <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      {DashboardMentorHomeList &&
                        DashboardMentorHomeList.date_applied &&
                        moment(DashboardMentorHomeList.date_applied).format(
                          "DD/MM/YYYY"
                        )}
                    </h4>
                  </div>
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      STATUS
                    </h5>
                    <div className="draftTooltip">
                      <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                        {DashboardMentorHomeList &&
                        DashboardMentorHomeList.applicationStatus ===
                          "REQUESTINFO"
                          ? "Request Info"
                          : DashboardMentorHomeList.applicationStatus ===
                            "UPDATEDINFO"
                          ? "Updated Info"
                          : DashboardMentorHomeList.applicationStatus}{" "}
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      COMMENTS
                    </h5>

                    <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      {DashboardMentorHomeList?.comments?.length > 30 ? (
                        <>
                          <span
                            className="tooltipicon"
                            style={{ position: "relative", top: "0.17rem" }}
                          >
                            {DashboardMentorHomeList?.comments.substring(0, 30)}

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="30"
                              fill="currentColor"
                              class="bi bi-three-dots"
                              viewBox="0 0 16 16"
                            >
                              <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                            </svg>
                            <span className="tooltiptext-Comment">
                              {DashboardMentorHomeList?.comments}
                            </span>
                          </span>
                        </>
                      ) : (
                        commentsData
                      )}
                    </h4>
                  </div>
                </div>
              </div>

              <div className="row w-100 lg-p-0 lg-m-0 sm-p-0 sm-m-0 d-flex justify-content-center">
                <div className="col-md-10 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div
                    className="mentor-purple-btn-view-dashboard unapprovedcard top-btn lg-p-0 lg-m-0 newuserTooltip "
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      ViewMentorApplicaiton(
                        DashboardMentorHomeList,
                        DashboardMentorHomeList.id,
                        DashboardMentorHomeList.applicationStatus
                      )
                    }
                  >
                    <a
                      className="blue-link"
                      onClick={() =>
                        ViewMentorApplicaiton(
                          DashboardMentorHomeList,
                          DashboardMentorHomeList.id,
                          DashboardMentorHomeList.applicationStatus
                        )
                      }
                    >
                      {DashboardMentorHomeList &&
                      DashboardMentorHomeList.applicationStatus == "REQUESTINFO"
                        ? "EDIT APPLICATION"
                        : DashboardMentorHomeList.applicationStatus == "DRAFT"
                        ? "COMPLETE APPLICATION "
                        : "VIEW MY APPLICATION"}
                    </a>
                    {DashboardMentorHomeList &&
                    DashboardMentorHomeList.applicationStatus ==
                      "REQUESTINFO" ? (
                      <span className="tooltiptext completeAppln tooltip-bottom">
                        Edit Application
                      </span>
                    ) : DashboardMentorHomeList.applicationStatus == "DRAFT" ? (
                      <span className="tooltiptext completeAppln tooltip-bottom">
                        Complete Application
                      </span>
                    ) : (
                      <span className="tooltiptext completeAppln tooltip-bottom">
                        View My Application
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-2 mentorKitButton newuserTooltip">
                  <a className="footerPdfBtn" target="_blank" href={pdfFile}>
                    <div
                      className="mentor-toolkit-btn top-btn"
                      style={{ cursor: "pointer" }}
                    />
                  </a>
                  <span className="tooltiptext mentorToolkit tooltip-bottom">
                    Mentor Toolkit
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="menteedashboard-data"
          style={{
            width: "auto",

            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <div className="container">
            <div className="mentor-content mt-20">
              <div className="row ">
                <div
                  className="col-lg-2 d-flex justify-content-center newuserTooltip"
                  onClick={() => ViewProfile(DashboardMentorHomeList)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    style={{
                      height: "150px",
                      width: "auto",
                    }}
                    src={
                      DashboardMentorHomeList &&
                      DashboardMentorHomeList.uploadProfilePic
                        ? DashboardMentorHomeList.uploadProfilePic
                        : hashImage
                    }
                  />
                  <span className="tooltiptext  tooltip-bottom mentor-I">
                    View Mentor Profile
                  </span>
                </div>

                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      MENTOR NAME
                    </h5>
                    <h4 className="mb-0 homepageFifthDescription">
                      {DashboardMentorHomeList &&
                        DashboardMentorHomeList.full_name}{" "}
                    </h4>
                  </div>
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      MENTOR ID
                    </h5>
                    <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      {DashboardMentorHomeList &&
                        getMentorId(DashboardMentorHomeList.mentorId)}
                    </h4>
                  </div>
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                    <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                      APPLICATION ID
                    </h5>
                    <div className="newuserTooltip">
                      <h4
                        className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          ViewMentorApplicaiton(
                            DashboardMentorHomeList,
                            DashboardMentorHomeList.id,
                            DashboardMentorHomeList.applicationStatus,
                            "ApplicationView"
                          )
                        }
                      >
                        {DashboardMentorHomeList &&
                          getApplicationId(DashboardMentorHomeList.id)}{" "}
                      </h4>
                      <span className="tooltiptext applicationdata tooltip-bottom">
                        View Application
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                    {DashboardMentorHomeList &&
                    DashboardMentorHomeList?.applicationStatus ===
                      "VERIFIED" ? (
                      <>
                        <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                          MENTORING
                        </h5>
                        <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              // marginTop: "10px",
                              transform: "translateX(10px)",
                              marginLeft: "-20px",
                            }}
                          >
                            <Box
                              style={{
                                height: "50px",
                                width: "50px",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background:
                                  "linear-gradient(45deg, rgba(83,255,250,1) 0%, rgba(118,95,170,1) 100%)",
                                color: "#fff",
                                fontWeight: "bold",
                              }}
                            >
                              {LoginData?.activeMentorships}
                            </Box>
                          </Box>
                        </h4>
                      </>
                    ) : (
                      <>
                        <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                          STATUS
                        </h5>
                        <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                          {DashboardMentorHomeList &&
                            DashboardMentorHomeList.applicationStatus}
                        </h4>
                      </>
                    )}
                  </div>
                </div>
                <div className="col-lg-2 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                  <div className="mentor-info lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                    {DashboardMentorHomeList &&
                    DashboardMentorHomeList?.applicationStatus ===
                      "VERIFIED" ? (
                      <>
                        <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0 homepageFifthDescription">
                          RATING
                        </h5>
                        <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              // marginTop: "10px",
                            }}
                          >
                            <Box
                              style={{
                                position: "relative",
                                width: "60px",
                                height: "60px",
                              }}
                            >
                              <img
                                src={StarIcon}
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  height: "85px",
                                  maxWidth: "none",
                                }}
                              />
                              <span
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -60%)",
                                  color: "white",
                                  fontWeight: "bold",
                                }}
                              >
                                {DashboardMentorHomeList &&
                                DashboardMentorHomeList?.mentorshipRating !=
                                  "NaN"
                                  ? Number(
                                      parseInt(
                                        DashboardMentorHomeList?.mentorshipRating
                                      ).toFixed(1)
                                    )
                                  : "0"}
                              </span>
                            </Box>
                          </Box>
                        </h4>
                      </>
                    ) : (
                      <>
                        <h5 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                          COMMENTS
                        </h5>
                        <h4 className="mb-0 lg-p-0 lg-m-0 sm-p-0 sm-m-0">
                          {DashboardMentorHomeList?.comments?.length > 30 ? (
                            <>
                              {commentsData}
                              <span
                                className="tooltipicon"
                                style={{ position: "relative", top: "0.17rem" }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="30"
                                  height="30"
                                  fill="currentColor"
                                  class="bi bi-three-dots"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                </svg>
                                <span className="tooltiptext4">
                                  {DashboardMentorHomeList?.comments}
                                </span>
                              </span>
                            </>
                          ) : (
                            commentsData
                          )}
                        </h4>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="row w-100">
                <div className="lg-col-2 sm-col-12 md-col-12 col-md-2 mt-3 newuserTooltip">
                  {LoginData?.badge &&
                  LoginData.applicationStatus === "VERIFIED" ? (
                    <div
                      className="row badgemobile"
                      style={{
                        paddingLeft: "15px",
                      }}
                    >
                      <div
                        class="mentor-box-newdash"
                        style={{
                          marginTop: "0%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            style={{
                              maxWidth: "65%",
                              marginTop: "-3px",
                            }}
                            src={
                              LoginData?.badge === "NEW"
                                ? newBadge
                                : LoginData?.badge === "SILVER"
                                ? silveradge
                                : LoginData?.badge === "GOLD"
                                ? goldBadge
                                : LoginData?.badge === "PLATINUM"
                                ? platinumBadge
                                : ""
                            }
                          />
                        </div>

                        <div class="row">
                          <div
                            class="col-md-7"
                            style={{ padding: "10px", paddingTop: "5px" }}
                          >
                            <img
                              style={{
                                maxWidth: "78%",
                                marginTop: "-11px",
                              }}
                              src={startupIndia}
                            />
                          </div>
                          <div class="col-md-5" style={{ padding: "0px" }}>
                            <p
                              style={{
                                marginTop: "-7px",
                                lineHeight: "13px",
                                paddingRight: "5px",
                              }}
                              class="mentor-date-new"
                            >
                              {getQuarter()}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <button
                        className="profileButton col-lg-2 top-btn"
                        onClick={() => ViewProfile(DashboardMentorHomeList)}
                      >
                        VIEW PROFILE
                      </button>
                      <span className="tooltiptext viewMentorProfile tooltip-bottom">
                        View Mentor Profile
                      </span>
                    </>
                  )}
                </div>

                <div className="mentorsharemobile">
                  <div>Share via</div>
                  <div>
                    <FacebookShareButton
                      url={
                        LoginData?.badge === "NEW"
                          ? `${API_URL()}v1/document/badge/new-mentor.6ce76cd0d9f0d3cdbc32.png`
                          : LoginData?.badge === "SILVER"
                          ? `${API_URL()}v1/document/badge/silver-mentor.af6fb1d291a3217bb72f.png`
                          : LoginData?.badge === "GOLD"
                          ? `${API_URL()}v1/document/badge/gold-mentor.20cb804c97a24b920a56.png`
                          : LoginData?.badge === "PLATINUM"
                          ? `${API_URL()}v1/document/badge/platinum-mentor.e542810b9ad3b1990089.png`
                          : ""
                      }
                      style={{
                        height: "35px",
                        width: "35px",
                        borderRadius: "50%",
                      }}
                    >
                      <FacebookIcon
                        style={{
                          height: "35px",
                          width: "35px",
                          borderRadius: "50%",
                        }}
                      />
                    </FacebookShareButton>
                    <LinkedinShareButton
                      url={
                        LoginData?.badge === "NEW"
                          ? `${API_URL()}v1/document/badge/new-mentor.6ce76cd0d9f0d3cdbc32.png`
                          : LoginData?.badge === "SILVER"
                          ? `${API_URL()}v1/document/badge/silver-mentor.af6fb1d291a3217bb72f.png`
                          : LoginData?.badge === "GOLD"
                          ? `${API_URL()}v1/document/badge/gold-mentor.20cb804c97a24b920a56.png`
                          : LoginData?.badge === "PLATINUM"
                          ? `${API_URL()}v1/document/badge/platinum-mentor.e542810b9ad3b1990089.png`
                          : ""
                      }
                      style={{
                        height: "35px",
                        width: "35px",
                        borderRadius: "50%",
                        marginLeft: "10px",
                      }}
                    >
                      <LinkedinIcon
                        style={{
                          height: "35px",
                          width: "35px",
                          borderRadius: "50%",
                        }}
                      />
                    </LinkedinShareButton>
                    <TwitterShareButton
                      url={
                        LoginData?.badge === "NEW"
                          ? `${API_URL()}v1/document/badge/new-mentor.6ce76cd0d9f0d3cdbc32.png`
                          : LoginData?.badge === "SILVER"
                          ? `${API_URL()}v1/document/badge/silver-mentor.af6fb1d291a3217bb72f.png`
                          : LoginData?.badge === "GOLD"
                          ? `${API_URL()}v1/document/badge/gold-mentor.20cb804c97a24b920a56.png`
                          : LoginData?.badge === "PLATINUM"
                          ? `${API_URL()}v1/document/badge/platinum-mentor.e542810b9ad3b1990089.png`
                          : ""
                      }
                      style={{
                        height: "35px",
                        width: "35px",
                        borderRadius: "50%",
                        marginLeft: "10px",
                      }}
                    >
                      <TwitterIcon
                        style={{
                          height: "35px",
                          width: "35px",
                          borderRadius: "50%",
                        }}
                      />
                    </TwitterShareButton>
                  </div>
                </div>
                <div
                  className="col-md-8 editprofilemobile"
                  style={{ position: "relative" }}
                >
                  <div className="editButtonFullScreen">
                    <div
                      className="mentor-purple-btn-view-dashboard2 unapprovedcard top-btn col-10 newuserTooltip"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        ViewMentorApplicaiton(
                          DashboardMentorHomeList,
                          DashboardMentorHomeList.id,
                          DashboardMentorHomeList.applicationStatus
                        )
                      }
                    >
                      <a
                        className="blue-link"
                        onClick={() =>
                          ViewMentorApplicaiton(
                            DashboardMentorHomeList,
                            DashboardMentorHomeList.id,
                            DashboardMentorHomeList.applicationStatus
                          )
                        }
                      >
                        {DashboardMentorHomeList &&
                        DashboardMentorHomeList.applicationStatus == "VERIFIED"
                          ? "EDIT PROFILE"
                          : "EDIT PROFILE"}
                      </a>
                      <span className="tooltiptext mentoreditProfile tooltip-bottom">
                        Edit Mentor Profile
                      </span>
                    </div>
                  </div>
                  {/* <div>
                    <div
                      className="dashboard-bottom-btn22 top-btn newuserTooltip"
                      onClick={() => {
                        localStorage.setItem(
                          "sessionRecording",
                          "sessionRecording"
                        );
                        window.location.reload();
                      }}
                      style={{
                        position: "relative",
                        left: "22.95rem",
                        fontSize: "16px",
                        top: "-4rem",
                        height: "52px !important",
                      }}
                    >
                      <p
                        style={{
                          cursor: "pointer",
                          fontSize: "16px",
                          left: "-1.5rem",
                          top: "-0.25rem",
                        }}
                        className="text-white3 createcohortsessionbtnpara"
                      >
                        SESSION RECORDINGS
                      </p>
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "130px", top: "60px", width: "220px" }}
                      >
                        Click to view Session Recordings
                      </span>
                    </div>
                  </div> */}
                  {LoginData?.badge != null ? (
                    <div style={{ position: "absolute", left: 0, bottom: 0 }}>
                      <div
                        style={{
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onMouseEnter={() => setIconsCollapse(true)}
                        onMouseLeave={() => setIconsCollapse(false)}
                        className="mentorshare"
                      >
                        <img
                          src={shareRounded}
                          style={{
                            height: "40px",
                            width: "40px",
                            cursor: "pointer",
                            marginRight: "10px",
                          }}
                        />
                        <Collapse in={iconsCollapse}>
                          <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                }}
                              >
                                Share on Facebook
                              </Typography>
                            }
                          >
                            <FacebookShareButton
                              url={
                                LoginData?.badge === "NEW"
                                  ? `${API_URL()}v1/document/badge/new-mentor.6ce76cd0d9f0d3cdbc32.png`
                                  : LoginData?.badge === "SILVER"
                                  ? `${API_URL()}v1/document/badge/silver-mentor.af6fb1d291a3217bb72f.png`
                                  : LoginData?.badge === "GOLD"
                                  ? `${API_URL()}v1/document/badge/gold-mentor.20cb804c97a24b920a56.png`
                                  : LoginData?.badge === "PLATINUM"
                                  ? `${API_URL()}v1/document/badge/platinum-mentor.e542810b9ad3b1990089.png`
                                  : ""
                              }
                              style={{
                                height: "35px",
                                width: "35px",
                                borderRadius: "50%",
                              }}
                            >
                              <FacebookIcon
                                style={{
                                  height: "35px",
                                  width: "35px",
                                  borderRadius: "50%",
                                }}
                              />
                            </FacebookShareButton>
                          </Tooltip>
                          <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                }}
                              >
                                Share on Linkedin
                              </Typography>
                            }
                          >
                            <LinkedinShareButton
                              url={
                                LoginData?.badge === "NEW"
                                  ? `${API_URL()}v1/document/badge/new-mentor.6ce76cd0d9f0d3cdbc32.png`
                                  : LoginData?.badge === "SILVER"
                                  ? `${API_URL()}v1/document/badge/silver-mentor.af6fb1d291a3217bb72f.png`
                                  : LoginData?.badge === "GOLD"
                                  ? `${API_URL()}v1/document/badge/gold-mentor.20cb804c97a24b920a56.png`
                                  : LoginData?.badge === "PLATINUM"
                                  ? `${API_URL()}v1/document/badge/platinum-mentor.e542810b9ad3b1990089.png`
                                  : ""
                              }
                              style={{
                                height: "35px",
                                width: "35px",
                                borderRadius: "50%",
                                marginLeft: "10px",
                              }}
                            >
                              <LinkedinIcon
                                style={{
                                  height: "35px",
                                  width: "35px",
                                  borderRadius: "50%",
                                }}
                              />
                            </LinkedinShareButton>
                          </Tooltip>
                          <Tooltip
                            classes={{
                              tooltip: classes.tooltip,
                              tooltipArrow: classes.tooltipArrow,
                            }}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow
                            title={
                              <Typography
                                style={{
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  color: "#fff",
                                  fontWeight: "bold",
                                }}
                              >
                                Share on Twitter
                              </Typography>
                            }
                          >
                            <TwitterShareButton
                              url={
                                LoginData?.badge === "NEW"
                                  ? `${API_URL()}v1/document/badge/new-mentor.6ce76cd0d9f0d3cdbc32.png`
                                  : LoginData?.badge === "SILVER"
                                  ? `${API_URL()}v1/document/badge/silver-mentor.af6fb1d291a3217bb72f.png`
                                  : LoginData?.badge === "GOLD"
                                  ? `${API_URL()}v1/document/badge/gold-mentor.20cb804c97a24b920a56.png`
                                  : LoginData?.badge === "PLATINUM"
                                  ? `${API_URL()}v1/document/badge/platinum-mentor.e542810b9ad3b1990089.png`
                                  : ""
                              }
                              style={{
                                height: "35px",
                                width: "35px",
                                borderRadius: "50%",
                                marginLeft: "10px",
                              }}
                            >
                              <TwitterIcon
                                style={{
                                  height: "35px",
                                  width: "35px",
                                  borderRadius: "50%",
                                }}
                              />
                            </TwitterShareButton>
                          </Tooltip>
                        </Collapse>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-2 mentorKitButton newuserTooltip mentortoolkitbtn">
                  <a className="footerPdfBtn" target="_blank" href={pdfFile}>
                    <div
                      className="mentor-toolkit-btn top-btn"
                      style={{ cursor: "pointer" }}
                    />
                  </a>
                  <span className="tooltiptext mentorToolkit tooltip-bottom">
                    Mentor Toolkit
                  </span>
                </div>
              </div>
            </div>
            {PRODUCTION_MOVE_HIDDEN ? (
              ""
            ) : (
              <ul className="startupdashboard-cards w-100 h-100 m-0 p-0">
                <li className="dashboard-cards_item2 newlowercard">
                  <div style={{ width: "100%" }}>
                    <div
                      className="dashboard-card-mentor5"
                      style={{ minHeight: "50%", height: "580px" }}
                    >
                      <div
                        className="dashboard-card_image"
                        style={{ marginTop: "27px", marginBottom: "7px" }}
                      >
                        <img className="mentorDashImg1" src={startupIcon} />
                      </div>
                      <div className="dashboard-card_content md-p-0 sm-p-0 lg-p-0">
                        <h3 className="dashboard-card-heading newBottomSpace homepageFourthDescription">
                          MENTORSHIP REQUESTS
                        </h3>
                        <div className="mentorDashChart1">
                          <Chart
                            options={options}
                            series={seriesMentor}
                            type="bar"
                            height={200}
                          />
                        </div>
                        <div className="inner-dashboard-view md-p-0 sm-p-0 lg-p-0 mentorBoxPosition">
                          <div className="rowC">
                            <div className="square1"></div>
                            <p className="homepageFifthDescription">
                              Total Requests :{" "}
                              <span>
                                {getCounterMentor && getCounterMentor.total}
                              </span>
                            </p>
                          </div>
                          <div className="rowC">
                            <div className="square2"></div>
                            <p className="homepageFifthDescription">
                              Total Accepted :{" "}
                              <span>
                                {getCounterMentor && getCounterMentor.accepted}
                              </span>
                            </p>
                          </div>
                          <div className="rowC">
                            <div className="square4"></div>
                            <p className="homepageFifthDescription">
                              Total Declined :{" "}
                              <span>
                                {getCounterMentor && getCounterMentor.rejected}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div
                          className="dashboard-purple-btn top-btn mt-2 mb-4 newuserTooltip"
                          style={{
                            width: "100%",
                            position: "relative",
                            top: "2.8rem",
                          }}
                          onClick={() => {
                            if (PRODUCTION_MOVE_HIDDEN) {
                              return;
                            }
                            props.setSelectedMenu("myrequestMenu");
                            history.push({
                              pathname: `/dashboard`,
                              state: { prevPage: "mentorDashboard" },
                            });
                          }}
                        >
                          <span
                            className="blue-link-dashboard2 mentorNew-Request"
                            style={{
                              paddingRight: "0px",
                              cursor: "pointer",
                              fontWeight: "600",
                            }}
                          >
                            {" "}
                            New Request :{" "}
                            {getCounterMentor && getCounterMentor.pending}
                          </span>
                          <span className="tooltiptext newMatch tooltip-bottom">
                            New Request{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="dashboard-cards_item2 newlowercard">
                  <div style={{ width: "100%" }}>
                    <div
                      className="dashboard-card-startup6"
                      style={{ minHeight: "50%", height: "580px" }}
                    >
                      <div
                        className="dashboard-card_image"
                        style={{ marginTop: "10px", marginBottom: "7px" }}
                      >
                        <img src={twoGears} className="startUpDashGear" />
                      </div>
                      <div className="dashboard-card_content">
                        <h3 className="dashboard-card-heading4 homepageFourthDescription">
                          MENTORSHIP HOURS
                        </h3>
                        <div
                          className="startUpChart3"
                          style={{ marginTop: "30px" }}
                        >
                          {/* <HorizontalBarChart chartData={Upperdata} /> */}
                          <Chart
                            options={optionshours}
                            series={seriesMentorHours}
                            type="bar"
                            height={200}
                          />
                        </div>

                        <div className="inner-dashboard-view startUpChart3">
                          <div className="rowC">
                            <div className="square1"></div>
                            <p className="homepageFifthDescription">
                              Till Date Scheduled :{" "}
                              <span>
                                {hours !== undefined
                                  ? parseFloat(
                                      hours.tillDateScheduledHours
                                    ).toFixed(2)
                                  : 0}
                              </span>
                            </p>
                          </div>
                          <div className="rowC">
                            <div className="square2"></div>
                            <p className="homepageFifthDescription">
                              Till Date Completed :{" "}
                              <span>
                                {hours !== undefined
                                  ? parseFloat(
                                      hours.tillDateCompletedHours
                                    ).toFixed(2)
                                  : 0}
                              </span>
                            </p>
                          </div>
                          <div className="rowC">
                            <div className="square3"></div>
                            <p className="homepageFifthDescription">
                              This Quarter Scheduled :{" "}
                              <span>
                                {" "}
                                {hours !== undefined
                                  ? parseFloat(
                                      hours.quarterScheduledHours
                                    ).toFixed(2)
                                  : 0}
                              </span>
                            </p>
                          </div>
                          <div className="rowC">
                            <div className="square4"></div>
                            <p className="homepageFifthDescription">
                              This Quarter Completed :{" "}
                              <span>
                                {" "}
                                {hours !== undefined
                                  ? parseFloat(
                                      hours.quarterCompletedHours
                                    ).toFixed(2)
                                  : 0}
                              </span>
                            </p>
                          </div>
                          <div
                            className="rowC"
                            style={{ paddingBottom: "6.5rem" }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="dashboard-cards_item2 newlowercard">
                  <div style={{ width: "100%" }}>
                    <div
                      className="dashboard-card-startup6"
                      style={{ minHeight: "50%", height: "580px" }}
                    >
                      <div
                        className="dashboard-card_image"
                        style={{ marginTop: "10px", marginBottom: "7px" }}
                      >
                        <img src={cohortIcon} className="cohortMeeting2" />
                      </div>

                      <div className="dashboard-card_content">
                        <h3 className="dashboard-card-heading4 homepageFourthDescription">
                          MENTORSHIP SESSIONS
                        </h3>
                        <div className="mentorDashItem2">
                          <Chart
                            options={optionsessions}
                            series={seriesMentorSessions}
                            type="bar"
                            height={200}
                          />
                        </div>

                        <div className="inner-dashboard-view mentorBoxItemPosition">
                          <div className="rowC">
                            <div className="square1"></div>
                            <p className="homepageFifthDescription">
                              Till Date Scheduled :{" "}
                              <span>
                                {session !== undefined
                                  ? session.tillDateScheduled
                                  : 0}
                              </span>
                            </p>
                          </div>
                          <div className="rowC">
                            <div className="square2"></div>
                            <p className="homepageFifthDescription">
                              Till Date Completed :{" "}
                              <span>
                                {" "}
                                {session !== undefined
                                  ? session.tillDateCompleted
                                  : 0}
                              </span>
                            </p>
                          </div>
                          <div className="rowC">
                            <div className="square3"></div>
                            <p className="homepageFifthDescription">
                              This Quarter Scheduled :{" "}
                              <span>
                                {" "}
                                {session !== undefined
                                  ? session.quarterScheduled
                                  : 0}
                              </span>
                            </p>
                          </div>
                          <div className="rowC">
                            <div className="square4"></div>
                            <p className="homepageFifthDescription">
                              This Quarter Completed :{" "}
                              <span>
                                {" "}
                                {session !== undefined
                                  ? session.quarterCompleted
                                  : 0}
                              </span>
                            </p>
                          </div>
                          <div className="rowC">
                            <div className="square5"></div>
                            <p className="homepageFifthDescription">
                              Upcoming :{" "}
                              <span>
                                {session !== undefined ? session.upcoming : 0}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div
                          className="dashboard-purple-btn top-btn tooltipicon mt-2 mb-4 mentorButtonPosition lastpurplebtn"
                          style={{
                            width: "100%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (PRODUCTION_MOVE_HIDDEN) {
                              return;
                            }
                            if (
                              session?.sessionSchedule?.sessionStart !==
                                undefined &&
                              session?.sessionSchedule?.sessionStart !== null &&
                              session?.sessionSchedule?.sessionStart !== 0
                            )
                              window.open(
                                `/mentor-dashboard/mentorships/engagement-summary/${session?.sessionSchedule?.mentorshipId}`,
                                "_blank"
                              );
                          }}
                        >
                          <div className="newuserTooltip">
                            <div
                              className="blue-link-dashboard2 mentornext-Seccion"
                              style={{
                                paddingRight: "0px",
                                cursor: "default",
                                fontWeight: "600",
                              }}
                            >
                              {" "}
                              {session?.sessionSchedule?.sessionStart === null ||
                            session?.sessionSchedule?.sessionStart ===
                              undefined ? (
                              <span
                                style={{
                                  position: "relative",
                                }}
                                className="mentorNew-Request2"
                              >
                                Next Session : -
                              </span>
                            ) : (
                              <>
                                <span
                                  style={{
                                    position: "relative",
                                    bottom: "0.6rem",
                                  }}
                                >
                                  Next Session :
                                </span>
                                <br />
                                <span
                                  style={{
                                    position: "relative",
                                    bottom: "1.3rem",
                                  }}
                                >
                                  {session?.sessionSchedule?.sessionStart !==
                                    undefined &&
                                  session?.sessionSchedule?.sessionStart !==
                                    null
                                    ? moment(
                                        session?.sessionSchedule?.sessionStart
                                      ).format("DD/MM/YYYY hh:mm A")
                                    : "--"}
                                </span>
                              </>
                            )}
                              {/* {session?.sessionSchedule?.sessionStart !==
                                undefined &&
                              session?.sessionSchedule?.sessionStart !== null
                                ? moment(
                                    session?.sessionSchedule?.sessionStart
                                  ).format("DD/MM/YYYY hh:mm A")
                                : "-"} */}
                              <span
                                className="tooltiptext  tooltip-bottom"
                                style={{
                                  fontFamily: "Montserrat",
                                  width: "150px",
                                  padding: "0px 12px",
                                  left: "29px",
                                  top: "48px",
                                }}
                              >
                                View Session Details
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            )}
          </div>
          {PRODUCTION_MOVE_HIDDEN ? (
            ""
          ) : (
            <div
              className="container startupButtonrow2 belowbtndiv"
              style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
            >
              <div className="row belowbtninnerdiv">
                <div
                  className="col-md-4 col-sm-9 col-lg-4 abovebenefitssec1 "
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="benefits-sec2 top-btn newuserTooltip"
                    onClick={() => {
                      if (PRODUCTION_MOVE_HIDDEN) {
                        return;
                      }
                      history.push("/dashboard");
                      props.setSelectedMenu("mentorMentorships");
                    }}
                  >
                    <a className="benefits-heading benheading">
                      MY MENTORSHIPS :{" "}
                      {/* {getCounterMentor && getCounterMentor.accepted} */}
                      {counterData ? counterData.active : "00"}
                    </a>
                    <span className="tooltiptext mentormymentorship  tooltip-bottom">
                      View Mentorships
                    </span>
                  </div>
                </div>
                <div
                  className="col-md-4 col-sm-6 col-lg-4 abovebenefitssec2"
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="benefits-sec2 top-btn newuserTooltip"
                    onClick={() => {
                      if (PRODUCTION_MOVE_HIDDEN) {
                        return;
                      }
                      props.setSelectedMenu("mentorMentorMessage");
                      history.push("/dashboard");
                    }}
                  >
                    <a className="benefits-heading benheading">
                      NEW MESSAGES :{" "}
                      {getNewMessagesData && getNewMessagesData?.unread}
                    </a>
                    <span className="tooltiptext mentormymentorship  tooltip-bottom">
                      View New Messages
                    </span>
                  </div>
                </div>
                <div
                  className="col-md-4 col-sm-6 col-lg-4 abovebenefitssec3"
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="benefits-sec2 top-btn newuserTooltip"
                    onClick={
                      () => {
                        if (
                          cohortRedirection !== undefined &&
                          cohortRedirection !== "" &&
                          cohortRedirection?.length !== 0 &&
                          cohortRedirection !== null &&
                          cohortRedirection?.cohortAdminId !== LoginData?.id
                        ) {
                          window.open(
                            `/cohort-programs/cohortView/${cohortRedirection?.cohortId}`,
                            "_blank"
                          );
                          localStorage.setItem("cohortWindow", "resources");
                          // let reRoute = window.open(
                          //   sample +
                          //     `/cohort-programs/all/${cohortRedirection?.cohortId}`,
                          //   "_blank"
                          // );
                        }
                      }
                      // history.push(`/cohort-programs/all/${item?.cohortID}`)
                    }
                  >
                    <a className="benefits-heading benheading">
                      NEXT PROGRAM :{" "}
                      {cohortRedirection !== undefined &&
                      cohortRedirection !== "" &&
                      cohortRedirection?.length !== 0 &&
                      cohortRedirection !== null
                        ? moment(cohortRedirection?.date).format("DD/MM/YYYY")
                        : "00"}
                    </a>
                    <span className="tooltiptext mentormymentorship  tooltip-bottom">
                      {cohortRedirection !== undefined &&
                      cohortRedirection !== "" &&
                      cohortRedirection?.length !== 0 &&
                      cohortRedirection !== null
                        ? "Click to open program"
                        : "No upcoming program"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {PRODUCTION_MOVE_HIDDEN
            ? ""
            : getListData &&
              getListData?.data?.length > 0 && (
                <div className="container mt-4 pendingrequestmentordash">
                  <div className="row">
                    <div className="sec-title text-center w-100 position-relative">
                      <h2 className="mb-0 rewquestpending">PENDING REQUEST </h2>
                    </div>
                    <div>
                      <div className="totalTableCount">
                        Total Records Found :{" "}
                        {getListDataPaginate !== undefined
                          ? getListDataPaginate?.totalElements
                          : "0"}{" "}
                        &lt;
                        {getListDataPaginate !== undefined
                          ? getListDataPaginate.currentPage
                          : "0"}{" "}
                        of{" "}
                        {getListDataPaginate !== undefined
                          ? getListDataPaginate.numPages
                          : "0"}{" "}
                        &gt;{" "}
                      </div>

                      <div
                        style={{
                          marginTop: "1%",
                          marginBottom: "3%",
                        }}
                      >
                        <table
                          className="table table-bordered"
                          style={{ fontSize: "16px" }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{ verticalAlign: "middle" }}
                                className="tableJustify fixColumbnWidth4"
                              >
                                No.
                              </th>
                              <th
                                style={{ verticalAlign: "middle" }}
                                className="fixTableHeading"
                                colspan="2"
                              >
                                Startup
                              </th>
                              <th>
                                Requirement <br />
                                Id
                              </th>

                              <th style={{ verticalAlign: "middle" }}>
                                Match %
                              </th>
                              <th
                                style={{
                                  width: "30%",
                                  verticalAlign: "middle",
                                }}
                              >
                                Purpose of Request
                              </th>
                              <th>
                                Request <br />
                                Status
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {getListData.data !== null &&
                              getListData.data !== undefined &&
                              getListData?.data.map((item, index) => (
                                <tr
                                  key={index}
                                  className={
                                    item.id === indexCounter
                                      ? "purpleBackground"
                                      : ""
                                  }
                                >
                                  {getListDataPaginate.currentPage === 1 ? (
                                    <td style={{ verticalAlign: "middle" }}>
                                      {index + 1}
                                    </td>
                                  ) : (
                                    <td style={{ verticalAlign: "middle" }}>
                                      {index +
                                        1 +
                                        10 *
                                          (getListDataPaginate.currentPage - 1)}
                                    </td>
                                  )}
                                  <td className="creatednewdivejustforheight">
                                    <div
                                      className="newuserTooltip"
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        maxWidth: "none",
                                        objectFit: "contain",
                                      }}
                                    >
                                      <img
                                        src={
                                          item.startupImage === null
                                            ? hashImage
                                            : item.startupImage
                                        }
                                        onClick={() => {
                                          setIndexCounter(item.id);
                                          redirectProfile(item.dpiitNumber);
                                        }}
                                        className="sidebar-dashboard-icon2"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          cursor: "pointer",

                                          objectFit: "contain",
                                        }}
                                      />
                                      <span
                                        className="tooltiptext tooltip-bottom "
                                        style={{
                                          left: "46px",
                                          top: "88px",
                                          width: "150px",
                                        }}
                                      >
                                        View Startup Profile
                                      </span>
                                      <p className="startupnameshouldhideforphone">
                                        {item.startupName}
                                      </p>
                                      <div
                                        className="d-flex justify-content-end newuserTooltip startupnameshouldhideforphone"
                                        style={{
                                          cursor: "pointer",

                                          right: "0px",
                                          bottom: "0px",
                                          left: "20px",
                                          padding: "12px",
                                        }}
                                        onClick={() => {
                                          setIndexCounter(item.id);
                                          redirectProfile(item.dpiitNumber);
                                        }}
                                      >
                                        <img
                                          src={profile}
                                          height={40}
                                          width={40}
                                        />

                                        <span
                                          className="tooltiptext  tooltip-bottom"
                                          style={{
                                            top: "60px",
                                            left: "15px",
                                            width: "150px",
                                          }}
                                        >
                                          View Startup Profile
                                        </span>
                                      </div>
                                    </div>
                                  </td>

                                  <td
                                    className="intentoffirstdivedata"
                                    style={{
                                      minWidth: "300px",
                                      position: "relative",
                                    }}
                                  >
                                    <div
                                      style={{
                                        flexDirection: "row",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        height: "100px",
                                        // maxWidth: "240px",
                                      }}
                                    >
                                      {" "}
                                      <div
                                        style={{
                                          cursor: "default",
                                          alignItems: "center",
                                          display: "flex",
                                          maxWidth: "240px",
                                        }}
                                      >
                                        {item.startupName}
                                      </div>
                                      <div
                                        className="d-flex justify-content-end newuserTooltip"
                                        style={{
                                          cursor: "pointer",

                                          position: "absolute",
                                          right: "0px",
                                          bottom: "0px",
                                          padding: "12px",
                                        }}
                                        onClick={() => {
                                          setIndexCounter(item.id);
                                          redirectProfile(item.dpiitNumber);
                                        }}
                                      >
                                        <img
                                          src={profile}
                                          height={40}
                                          width={40}
                                        />

                                        <span
                                          className="tooltiptext  tooltip-bottom"
                                          style={{
                                            top: "60px",
                                            left: "15px",
                                            width: "150px",
                                          }}
                                        >
                                          View Startup Profile
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    className="togglediv"
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    <div
                                      className="newuserTooltip"
                                      style={{ marginBottom: "-15px" }}
                                    >
                                      <a
                                        onClick={() => {
                                          ViewMentorApplication(item);
                                        }}
                                        className="color-green"
                                      >
                                        {getAppId(item.searchId)}
                                      </a>
                                      <span
                                        className="tooltiptext  tooltip-bottom"
                                        style={{ left: "40px", width: "163px" }}
                                      >
                                        View Requirement
                                      </span>
                                    </div>
                                    <br />
                                    {moment(item.requestToMentorDate).format(
                                      "DD/MM/YYYY "
                                    )}
                                    <br />
                                    {moment(item.requestToMentorDate).format(
                                      " hh:mm A"
                                    )}
                                  </td>
                                  <td
                                    style={{ verticalAlign: "middle" }}
                                    className="togglediv2"
                                  >
                                    <div>
                                      <a
                                        onClick={() => {
                                          ViewMentorApplication(item);
                                        }}
                                        className="color-green"
                                      >
                                        {getAppId(item.searchId)}
                                      </a>

                                      <br />

                                      {moment(item.requestToMentorDate).format(
                                        "DD/MM/YYYY "
                                      )}
                                      <br />
                                      {moment(item.requestToMentorDate).format(
                                        " hh:mm A"
                                      )}
                                    </div>
                                  </td>

                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      minWidth: "0.9rem",
                                    }}
                                  >
                                    {item?.total_percentage === null ||
                                    item?.total_percentage === undefined
                                      ? "NA"
                                      : item?.total_percentage + " %"}
                                  </td>

                                  {item?.purposeOfMentorship?.length > 150 ? (
                                    <td
                                      className="maxmajic"
                                      style={{
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <div className="tooltipicon">
                                        {item?.purposeOfMentorship.substring(
                                          0,
                                          150
                                        )}
                                        <svg
                                          style={{
                                            position: "relative",
                                            top: "0.1rem",
                                            cursor: "pointer",
                                          }}
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          class="bi bi-three-dots"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                        </svg>
                                        <span
                                          className="tooltiptext7"
                                          style={{
                                            top: "-112px",
                                            left: "103px",
                                          }}
                                        >
                                          <h5 style={{ color: "#fff" }}>
                                            Purpose of Request
                                          </h5>
                                          {item?.purposeOfMentorship}
                                        </span>
                                      </div>
                                    </td>
                                  ) : (
                                    <td
                                      className="maxmajic"
                                      style={{
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {item?.purposeOfMentorship}
                                    </td>
                                  )}

                                  {item.requestStatus === "Accepted" ? (
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <div>{item.requestStatus}</div>{" "}
                                      <div
                                        className="d-flex justify-content-end newuserTooltip"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          if (item?.mentorshipId !== null) {
                                            setIndexCounter(item.id);

                                            window.open(
                                              `/mentor-dashboard/mentorships/engagement-summary/${item?.mentorshipId}`,
                                              "_blank"
                                            );
                                          } else {
                                            props.setSelectedMenu(
                                              "mentorMentorships"
                                            );
                                            history.push("/dashboard");
                                          }
                                        }}
                                      >
                                        <img
                                          style={{
                                            height: "30px",
                                            width: "30px",
                                            marginTop: "10px",
                                          }}
                                          src={mentorshipIcon}
                                          alt={item.title}
                                        />

                                        <span className="tooltiptext-icon tooltip-bottom-icon mentorshipToolTipFix">
                                          View Engagement
                                        </span>
                                      </div>
                                    </td>
                                  ) : item.requestStatus === "Declined" ? (
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {item.requestStatus}
                                    </td>
                                  ) : (
                                    <td
                                      className="applicationStatusMentorapp contentrightselectbox"
                                      style={{
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <div
                                        className="rowC newuserTooltip"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <Select
                                          required={true}
                                          id="Status"
                                          variant="outlined"
                                          fullWidth
                                          margin="normal"
                                          type="State"
                                          name="Status"
                                          className="col-12 "
                                          styles={customStyles}
                                          isSearchable={false}
                                          // value={filterData6}
                                          onChange={(e) => {
                                            setUpdateApplicationStatus(
                                              e.value,
                                              item.searchId
                                            );
                                          }}
                                          options={approvalOptions}
                                          placeholder="Select"
                                        />
                                        <span
                                          className="tooltiptext tooltip-bottom"
                                          style={{
                                            left: "34px",
                                            top: "50px",
                                            width: "170px",
                                          }}
                                        >
                                          Change Request Status
                                        </span>
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              ))}
                          </tbody>
                        </table>

                        <div className="pagination-box">
                          {getListData ? (
                            <Pagination
                              activePage={activePage}
                              itemsCountPerPage={10}
                              totalItemsCount={
                                getListDataPaginate?.totalElements
                              }
                              pageRangeDisplayed={5}
                              onChange={handlePageChange.bind(this)}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    DashboardMentorHomeList: state.MentorReducer.DashboardMentorHomeList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getListData: state.MentorReducer.MentorApplicationList,
    getCounter: state.AdminMentorReducer.getCountersList.data,
    getListDataPaginate: state.MentorReducer.MentorApplicationList.paginate,
    getCounterMentor: state.MentorReducer.getCountersMentorList.data,
    getSession: state.AdminMentorReducer.getCountersSessions.data,
    getNewMessagesData: state.StartUpReducer.getNewMessages.data,
    // getCohortTableData: state.MentorReducer.getCohortForMentorList.data,
    getListCohortData: state.MentorReducer.getCohortForMentorList.data,
    getCohortTableData: state.MentorReducer.getCohortMentorModuleList.data,
  };
};

const setOpen = () => (dispatch) => {
  dispatch({ type: types.SET_OPEN });
};

export default connect(mapStateToProps, {
  getMentorHome,
  getPredefineOptionsList,
  getMentorStartUpApplicationList,
  setMentorStartUpStatus,
  getCountersList,
  getCountersSessions,
  getCountersMentorList,
  getNewMessagesDash,
  setOpen,
  getCohortMentorList,
})(withRouter(MentorHome));
